<template>
    <div>
    <b-form>
        <!-- <fr-social-buttons v-if="!isSocialReg" :signin="false"></fr-social-buttons> -->
            <div class="ssrv-header-0">

                <div class="ssrv-sub-hdr-1">

                    <div class="ssrv-hdr-1">
                    </div>
                    <h2>
                        {{ $t('pages.selfservice.registration.sadForm.rrcSadForm') }}
                    </h2>
                </div>
            </div>
            <div class="ssrv-top-0">
                <div class="ssrv-6" style="font-weight: bold">
                    {{ $t('pages.selfservice.registration.sadForm.sad') }}
                </div>
                <div class="ssrv-6" style="font-weight: bold">
                    {{ $t('pages.selfservice.registration.sadForm.forElectronicFiling') }}
                </div>
                <br>
                <div class="ssrv-0">
                    <div class="ssrv-0">
                        <div class="ssrv-0 lbl" style="text-align: left">Company exists in RAMP?</div>
                        <br>
                        <div class="ssrv-0">
                            <b-form-group label-class="ssrv-form-control lbl" style="text-align: left; float: left;">
                                <legend class="legend">Company exists in RAMP?</legend>
                                <div class="ssrv-5 lbl">
                                    <b-form-radio style="display: inline" name="companyExistsRad" v-model="companyExists" v-bind:value="true">--- Yes</b-form-radio>
                                </div>
                                <div class="ssrv-1 rad lbl">
                                    <b-form-radio style="display: inline" name="companyExistsRad" v-model="companyExists" v-bind:value="false">--- No</b-form-radio>
                                </div>
                            </b-form-group>
                        </div>
                        <br>
                        <br>
                        <br>
                        <div class="ssrv-0">
                            <div class="ssrv-0 lbl">Select Company Type</div>
                        </div>
                        <br>
                        <div class="ssrv-0">
                            <b-form-group label-class="ssrv-form-control lbl">
                                <legend class="legend" style="text-align: left">Select Company Type</legend>
                                <div class="ssrv-5 lbl" style="display: block">
                                    <b-form-radio style="display: block" name="companyTypeRad" v-model="companyIdType" value="RR">--- Oil & Gas/Pipelines/Gas Utility</b-form-radio>
                                </div>
                                <div class="ssrv-5 rad lbl" style="display: block">
                                    <b-form-radio style="display: block" name="companyTypeRad" v-model="companyIdType" value="AF">--- Alternative Fuels</b-form-radio>
                                </div>
                                <div class="ssrv-5 rad lbl" style="display: block">
                                    <b-form-radio style="display: block" name="companyTypeRad" v-model="companyIdType" value="SM">--- Surface Mining</b-form-radio>
                                </div>
                                <div class="ssrv-5 rad lbl" style="display: block">
                                    <b-form-radio style="display: block" name="companyTypeRad" v-model="companyIdType" value="CL">--- Consultant/Lawyer</b-form-radio>
                                </div>
                            </b-form-group>
                        </div>
                        <div class="ssrv-0">
                            <div class="ssrv-1">
                                <label for="companyName" class="safeLabel">Company Name</label>
                                <b-form-input id="companyName" v-if="showCompanyNameField()" v-model="saveDetails.companyName" class="ssrv-form-control" v-on:input="debouncedValidation('companyName')" :placeholder="userDetails.companyName.description"></b-form-input>
                            </div>
                            <div class="ssrv-50" v-if="showCompanyNameField() && this.validProperties.companyNameError" style="font-color:red;color:red">{{ validProperties.companyName }}</div>
                        </div>
                        <div class="ssrv-0">
                            <div class="ssrv-1">
                                <label for="orgIdentifier" class="safeLabel" v-if="showCompanyIdField()">{{ companyIdType }} Organization Identifier</label>
                                <b-form-input id="orgIdentifier" v-if="showCompanyIdField()" v-model="saveDetails.rrcP5Number" v-on:input="debouncedValidation('rrcP5Number')" class="ssrv-form-control" :placeholder="'ID Number'"></b-form-input>
                            </div>
                            <div class="ssrv-50" v-if="showCompanyIdField() && this.validProperties.rrcP5NumberError" style="font-color:red;color:red">{{ validProperties.rrcP5Number }}</div>
                        </div>
                    </div>
                    <div class="ssrv-0 ctf">
                        <div class="ssrv-0">
                            <div class="ssrv-1">
                                <label for="mail" class="safeLabel">{{ userDetails.mail.description }}</label>
                                <b-form-input id="mail" v-model="saveDetails.mail" v-on:input="debouncedValidation('mail')" class="ssrv-form-control" :placeholder="userDetails.mail.description" v-validate.initial="'email'" ></b-form-input>
                            </div>
                            <div class="ssrv-50" v-if="this.validProperties.mailError" style="font-color:red;color:red">{{ validProperties.mail }}</div>
                        </div>
                    </div>
                    <div class="ssrv-0">
                        <div class="ssrv-0">
                            <div class="ssrv-1">
                                <label for="firstName" class="safeLabel">First Name</label>
                                <b-form-input id="firstName" v-model="saveDetails.givenName" v-on:input="debouncedValidation('givenName')" class="ssrv-form-control" :placeholder="'First Name'"></b-form-input>
                            </div>
                            <div class="ssrv-50" v-if="this.validProperties.givenNameError" style="font-color:red;color:red">{{ validProperties.givenName }}</div>
                        </div>
                    </div>
                    <div class="ssrv-0">
                        <div class="ssrv-0">
                            <div class="ssrv-1">
                                <label for="lastName" class="safeLabel">Last Name</label>
                                <b-form-input id="lastName" v-model="saveDetails.sn" v-on:input="debouncedValidation('sn')" class="ssrv-form-control" :placeholder="'Last Name'"></b-form-input>
                            </div>
                            <div class="ssrv-50" v-if="this.validProperties.snError" style="font-color:red;color:red">{{ validProperties.sn }}</div>
                        </div>
                    </div>
                    <div class="ssrv-0">
                        <div class="ssrv-0">
                            <div class="ssrv-1">
                                <label for="suffix" class="safeLabel">Suffix</label>
                                <b-form-input id="suffix" v-model="saveDetails.suffix" v-on:input="debouncedValidation('suffix')" class="ssrv-form-control" :placeholder="'Suffix'"></b-form-input>
                            </div>
                            <div class="ssrv-50" style="font-color:red;color:red">{{ validProperties.suffix }}</div>
                        </div>
                    </div>
                    <div class="ssrv-0">
                        <div class="ssrv-0">
                            <div class="ssrv-1">
                                <label for="phone" class="safeLabel">{{ userDetails.telephoneNumber.description }}</label>
                                <b-form-input id="phone" v-model="saveDetails.telephoneNumber" v-on:input="debouncedValidation('telephoneNumber')" class="ssrv-form-control" :placeholder="userDetails.telephoneNumber.description"></b-form-input>
                            </div>
                            <div class="ssrv-50" v-if="this.validProperties.telephoneNumberError" style="font-color:red;color:red">{{ validProperties.telephoneNumber }}</div>
                        </div>
                    </div>
                    <div class="ssrv-0" v-if="companyIdType === 'AF'">
                        <div class="ssrv-0">
                            <div class="ssrv-1">
                                <label for="lastFourSSN" class="safeLabel">
                                    Last 4 SSN <span style="color:red;">*</span> (Required for AF Orgs)
                                </label>
                                <b-form-input
                                    id="lastFourSSN"
                                    v-model="saveDetails.lastFourSSN"
                                    class="ssrv-form-control"
                                    :placeholder="'Last 4 digits of SSN'"
                                    maxlength="4"
                                    @input="debouncedValidation('lastFourSSN')"
                                    required
                                ></b-form-input>
                            </div>
                            <div class="ssrv-50" v-if="validProperties.lastFourSSNError" style="color:red;">
                                {{ validProperties.lastFourSSN }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="ssrv-space"></div>

            </div>
            <br>
            <div class="ssrv-mid-0">
                <div>
                    <div class="ssrv-6" style="font-weight: bold">
                        {{ $t('pages.selfservice.registration.sadForm.certification') }}
                    </div>
                    <div class="ssrv-hdr-0">
                        <div class="ssrv-hdr-0">
                            {{ $t('pages.selfservice.registration.sadForm.certStatement') }}
                        </div>
                        <div class="ssrv-hdr-0">
                            {{ $t('pages.selfservice.registration.sadForm.certStatement2') }}
                        </div>
                        <div class="ssrv-hdr-0">
                            {{ $t('pages.selfservice.registration.sadForm.certStatement3') }}
                        </div>
                        <div class="ssrv-hdr-0">
                            {{ $t('pages.selfservice.registration.sadForm.certStatement4') }}
                        </div>
                        <div class="ssrv-hdr-0">
                            {{ $t('pages.selfservice.registration.sadForm.certStatement5') }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="ssrv-0">
                <div style="float: left; padding-left: 20px">
                    <div><input type="checkbox" id="checkbox" v-model="termsAgreed"></div>
                </div>
                <div style="float: left; width: 80%">
                    <div><label for="checkbox">I agree with these restrictions.</label></div>
                </div>
            </div>
            <div class="ssrv-0" style="float: left">
                <div class="ssrv-1">
                    <label for="sign" class="safeLabel">Type in your name to sign</label>
                    <b-form-input id="sign" v-model="saveDetails.certification" class="ssrv-form-control" :placeholder="saveDetails.givenName + ' ' + saveDetails.sn"></b-form-input>
                    <br>
                </div>
            </div>
            <!--
            <b-form-group class="mb-0" v-for="(property, key) in userDetails" :key="key">
                <fr-floating-label-input
                    :defaultValue="property.socialValue"
                    :fieldName="key"
                    :label="property.description"
                    :validateRules="calculateValidation(property)"
                    type="text"
                    v-model="saveDetails[key]"></fr-floating-label-input>
            </b-form-group>
            -->
                <!--
            <div class="ssrv-0">
                <fr-policy-password-input v-if="!isSocialReg" policyApi="selfservice/registration" v-model="saveDetails.password" name="password"></fr-policy-password-input>
            </div>
            -->
            <!-- Vue Bootstrap custom radio button seems to have problems so just using none component-->
                <!--
            <div class="form-group mb-4">
                <div v-for="(preference, key) in userPreferences" :key="key" class="custom-control custom-checkbox mb-2">
                    <input v-model="saveDetails.preferences[key]" type="checkbox" class="custom-control-input" :id="key">
                    <label class="custom-control-label" :for="key">{{preference.description}}</label>
                </div>
            </div>
            -->
            <div class="ssrv-0">
                <div class="ssrv-3">
                    <b-button  @click="save" :block="true" size="lg" variant="primary" active-class="ssrv-form-button" class="ssrv-form-button" :disabled="!certificationPassed">
                        {{$t("common.form.signUp")}}
                    </b-button>
                </div>
            </div>
            <!-- modal to show a user successfully sent their account creation request -->
            <b-modal id="successModal"
                     ref="successModal"
                     :title="this.$t('pages.selfservice.registration.sadForm.successModalTitle')">

                <div>
                    {{$t('pages.selfservice.registration.sadForm.successConfirm')}}
                </div>

                <div slot="modal-footer" class="w-100">
                    <div class="float-right">
                        <b-btn type="button" @click="successRequest">{{$t('common.form.confirm')}}</b-btn>
                    </div>
                </div>
            </b-modal>
        </b-form>

    </div>
</template>

<script>
import _ from 'lodash';
// import FloatingLabelInput from '@/components/utils/FloatingLabelInput';
// import PolicyPasswordInput from '@/components/utils/PolicyPasswordInput';
// import SocialButtons from '@/components/utils/SocialButtons';

/**
 * @description Selfservice stage for generating user details and displaying social buttons available. Works the same alone and in allinone
 *
 **/
export default {
    name: 'User-Details',
    components: {
        // 'fr-floating-label-input': FloatingLabelInput,
        // 'fr-policy-password-input': PolicyPasswordInput,
        // 'fr-social-buttons': SocialButtons
    },
    $_veeValidate: {
        validator: 'new'
    },
    props: {
        selfServiceDetails: { required: true },
        inline: {
            required: false,
            default: false
        }
    },
    data () {
        var data = {
            userDetails: {},
            saveDetails: {},
            userPreferences: {},
            isOperator: true,
            companyIdType: 'RR',
            companyExists: true,
            termsAgreed: false,
            isSocialReg: _.get(this.selfServiceDetails, 'tag') !== 'initial',
            validProperties: {
                companyName: '',
                companyNameError: true, // Set to false to remove validation
                rrcP5Number: '',
                rrcP5NumberError: true, // Set to false to remove validation restriction
                mail: '',
                mailError: true,
                givenName: '',
                givenNameError: true,
                sn: '',
                snError: true,
                suffix: '',
                suffixError: false, // No need to validate initially
                telephoneNumber: '',
                telephoneNumberError: true,
                lastFourSSN: '',
                lastFourSSNError: false // Set to true to enforce validation
            },
            debounceTimer: null,
            debounceTimeout: 500
        };

        if (this.selfServiceDetails.requirements && this.selfServiceDetails.requirements.registrationProperties) {
            data.userDetails = this.selfServiceDetails.requirements.registrationProperties.properties;

            if (_.has(this.selfServiceDetails, 'requirements.properties.user.default') &&
                    !_.isUndefined(this.selfServiceDetails, 'requirements.properties.user.default')) {
                _.each(this.selfServiceDetails.requirements.properties.user.default, (value, key) => {
                    data.userDetails[key].socialValue = value;
                });
            }

            _.each(this.selfServiceDetails.requirements.registrationProperties.required, (prop) => {
                data.userDetails[prop].required = true;
            });

            _.each(this.selfServiceDetails.requirements.registrationProperties.properties, (value, key) => {
                data.saveDetails[key] = '';
            });
        }

        if (this.selfServiceDetails.requirements && this.selfServiceDetails.requirements.registrationPreferences) {
            data.saveDetails.preferences = {};
            data.userPreferences = this.selfServiceDetails.requirements.registrationPreferences;

            _.each(data.userPreferences, (value, key) => {
                data.saveDetails.preferences[key] = false;
            });
        }

        data.saveDetails.password = '';

        return data;
    },
    computed: {

        // Check if the checkbox is checked, and the user signed their name as entered in the fields above
        certificationPassed () {
            if (this.saveDetails.givenName && this.saveDetails.sn) {
                if (this.saveDetails.givenName.length > 0 && this.saveDetails.sn.length > 0) {
                    let fullName = this.saveDetails.givenName + ' ' + this.saveDetails.sn;

                    if (this.termsAgreed && this.saveDetails.certification !== undefined && this.saveDetails.certification.toLowerCase() === fullName.toLowerCase()) {
                        // Check for invalid fields
                        console.log('VALID PROPS: ' + JSON.stringify(this.validProperties));
                        for (let error in this.validProperties) {
                            if (error.indexOf('Error') !== -1) {
                                if (this.validProperties[error]) {
                                    return false;
                                }
                            }
                        }

                        if (this.companyIdType === 'AF') {
                            if (
                                !this.saveDetails.lastFourSSN ||
                                this.validProperties.lastFourSSNError
                            ) {
                                return false;
                            }
                        }
                        return true;
                    }
                }
            }
            return false;
        }
    },
    methods: {
        getData () {
            let details = _.clone(this.saveDetails);

            delete details.confirmPassword;

            if (this.isSocialReg) {
                delete details.password;
            }

            return {
                user: details
            };
        },

        // Add additional frontend checks for field validation here
        calculateValidation (property) {
            let validators = [];

            if (property.required) {
                validators.push('required');
            }

            if (property.policies) {
                // Add policy vee validators correlations here
                _.each(property.policies, (policy) => {
                    if (policy.policyId === 'valid-email-address-format') {
                        validators.push('email');
                    }
                });
            }

            return validators.join('|');
        },

        showCompanyNameField () {
            if (this.companyExists === true || this.companyIdType === 'CL') {
                return true;
            }
            if (this.companyIdType === 'AF' || this.companyIdType === 'SM' || this.companyIdType === 'RR') {
                return true;
            }
            this.validProperties.companyNameError = false;
            return false;
        },

        showCompanyIdField () {
            if (this.companyExists === false) {
                if (this.companyIdType === 'CL') {
                    this.validProperties.rrcP5NumberError = false;
                    return false;
                }
            }
            return true;
        },

        offFocus (property) {
            if (property === 'lastFourSSN') {
                // Always clear error if not AF
                if (this.companyIdType !== 'AF') {
                    this.saveDetails.lastFourSSN = '';
                    this.validProperties.lastFourSSN = '';
                    this.validProperties.lastFourSSNError = false;
                    return;
                }
                // Show error if empty, too short, or not all digits
                if (!this.saveDetails.lastFourSSN) {
                    this.validProperties.lastFourSSN = 'Please enter the last 4 digits of your SSN.';
                    this.validProperties.lastFourSSNError = true;
                    return;
                }
                if (!/^\d{4}$/.test(this.saveDetails.lastFourSSN)) {
                    this.validProperties.lastFourSSN = 'SSN must be exactly 4 digits.';
                    this.validProperties.lastFourSSNError = true;
                    return;
                }
                // Input is valid!
                this.validProperties.lastFourSSN = '';
                this.validProperties.lastFourSSNError = false;
                // No need to API call for purely format validation.
                return;
            }
            var obj = {}, loginServiceInstance,
                wfdata = '';
            obj = {
                'object': {
                    'description': 'Validate object for selfservice.'
                },
                'properties': {}
            };
            obj.properties[property] = this.saveDetails[property];
            wfdata = JSON.stringify(obj);
            console.log('WFDATA: ' + wfdata);
            loginServiceInstance = this.getRequestService({
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/json'
                }
            });
            // console.log(wfdata);
            loginServiceInstance.post('policy/managed/user/test?_action=validateProperty', wfdata)
                .then((response) => {
                    if (response.data.failedPolicyRequirements.length > 0 && response.data.failedPolicyRequirements[0].policyRequirements.length > 0) {
                    // came back WITH a *validation* error
                        var errCode = response.data.failedPolicyRequirements[0].policyRequirements[0].policyRequirement,
                            errStringify = JSON.stringify(errCode),
                            subStr = errStringify.substring(1, errStringify.length - 1),
                            myStr = 'common.policyValidationMessages.' + subStr;

                        // console.log(this.$t(myStr));
                        this.validProperties[property] = this.$t(myStr);
                        this.validProperties[property + 'Error'] = true;
                    } else {
                        // came back withOUT a *validation* error
                        this.validProperties[property] = '';
                        this.validProperties[property + 'Error'] = false;
                    }
                    // console.log(JSON.stringify(response.data));

                    // console.log(JSON.stringify(this.validProperties));
                })
                .catch(function (error) {
                    error = undefined;
                    // console.log(error);
                });
            // console.log('This is after the api call is made');
        },

        debouncedValidation (property) {
            clearTimeout(this.debounceTimer);
            this.debounceTimer = setTimeout(() => {
                this.offFocus(property);
            }, this.debounceTimeout);
        },
        save () {
            var wfdata, wfObj, loginServiceInstance, companyId;
            loginServiceInstance = this.getRequestService({
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/json'
                }
            });
            wfObj = {
                'userName': `${this.saveDetails.mail}`,
                'givenName': `${this.saveDetails.givenName}`,
                'sn': `${this.saveDetails.sn}`,
                'mail': `${this.saveDetails.mail}`,
                'telephoneNumber': `${this.saveDetails.telephoneNumber}`,
                'companyName': `${this.saveDetails.companyName}`,
                'organization': `${companyId}`
            };
            if (this.companyExists) {
                if (this.companyIdType !== undefined) {
                    wfObj.organization = this.companyIdType + '-' + this.saveDetails.rrcP5Number;
                }
                wfObj._key = 'contractorOnboarding20';
                if (this.companyIdType === 'AF' && this.saveDetails.lastFourSSN) {
                    wfObj.lastFourSSN = `${this.saveDetails.lastFourSSN}`;
                }
                wfdata = JSON.stringify(wfObj);
                loginServiceInstance.post('workflow/processinstance?_action=create', wfdata)
                    .then(function (response) {
                        console.log('Workflow process instance created successfully.');
                    })
                    .catch(function (error) {
                        console.log('Error in workflow process instance creation: ' + error);
                    });
                console.log('This is after the api call is made');
                this.$refs.successModal.show();
            } else { // Company does not exist
                wfObj._key = 'organizationOnboarding15';
                if (this.companyIdType !== undefined) {
                    if (this.companyIdType === 'CL') {
                        loginServiceInstance.get('managed/counter?_queryFilter=name+eq+"CL"').then((counterResponse) => {
                            var counterData, newSerialStr, oldSerial, newSerial, counterId, dataObj, clserialArray, serialId, JSONobj = JSON.parse(JSON.stringify(counterResponse));
                            dataObj = JSONobj.data['result'];
                            serialId = dataObj[0]['serial'];
                            counterId = dataObj[0]['_id'];
                            // increment the counter and save it back
                            oldSerial = parseInt(serialId, 10);
                            newSerial = oldSerial;
                            newSerial++;
                            newSerialStr = newSerial.toString();
                            clserialArray = 'CL-' + serialId;
                            wfObj.organization = clserialArray;
                            wfdata = JSON.stringify(wfObj);
                            loginServiceInstance.post('workflow/processinstance?_action=create', wfdata)
                                .then(function (response) {
                                })
                                .catch(function (error) {
                                    error = undefined;
                                });
                            // Pad the front with leading 0's for 6 digits total (confirm if needed)
                            let serialArray,
                                arrayLen = newSerialStr.length >= 6 ? newSerialStr.length : (6 - newSerialStr.length);
                            serialArray = new Array(arrayLen);
                            this.setAll(serialArray, 0);
                            serialArray.push(newSerialStr);
                            counterData = JSON.stringify([{
                                'operation': 'replace',
                                'field': '/serial',
                                'value': `${serialArray.join('')}`
                            }]);
                            loginServiceInstance.patch('managed/counter/' + counterId, counterData).then((counterUpdate) => {
                                // Counter Updated.
                            }).catch((error) => {
                                error = undefined;
                                this.popupState = this.$t('pages.orgadmin.fail');
                            });
                        }).catch((error) => {
                            error = undefined;
                            this.popupState = this.$t('pages.orgadmin.fail');
                        });
                    } else {
                        // Any org type except CL
                        wfObj.organization = this.companyIdType + '-' + this.saveDetails.rrcP5Number;
                        // Include lastFourSSN only if org is AF
                        if (this.companyIdType === 'AF' && this.saveDetails.lastFourSSN) {
                            wfObj.lastFourSSN = `${this.saveDetails.lastFourSSN}`;
                        }
                        wfdata = JSON.stringify(wfObj);
                        loginServiceInstance.post('workflow/processinstance?_action=create', wfdata)
                            .then(function (response) {
                            })
                            .catch(function (error) {
                                error = undefined;
                            });
                    }
                }
                this.$refs.successModal.show();
            }
        },
        successRequest () {
            window.location.href = 'https://www.rrc.texas.gov/';
        },

        isValid () {
            /* istanbul ignore next */
            return this.$validator.validateAll();
        },

        setAll (a, v) {
            var i, n = a.length;
            for (i = 0; i < n; ++i) {
                a[i] = v;
            }
        }
    },
    watch: {
        'telephoneNumber': function (newVal) {
            console.log('NEW VAL:' + newVal);
            this.offFocus('telephoneNumber');
        },
        companyIdType (newType, oldType) {
            if (newType !== 'AF') {
                this.saveDetails.lastFourSSN = '';
                this.validProperties.lastFourSSN = '';
                this.validProperties.lastFourSSNError = false;
            }
        }
    }
};
</script>

<style scoped lang="scss">
.safeLabel {
    float: left;
}
.legend {
    float: left;
    font-family: $fr-typeface;
    font-size: .875rem;
    display: none;
}
.ssrv-form-button {
    background-color: #0054AD;
}
</style>
